<template>
  <div class="status">
    <span class="status-enabled" v-if="status === 1">
      {{ $t('application_table_status_enable') }}
    </span>
    <span class="status-disabled" v-else>
      {{ $t('application_table_status_disable') }}
    </span>
  </div>
</template>
<script>
export default {
  props: {
    status: {
      type: [Boolean, Number],
    },
  },
};
</script>
<style lang="less" scoped>
.status {
  display: flex;
  align-items: center;
  height: 20px;
  span {
    display: flex;
    align-items: center;
    padding: 1px 8px;
    text-align: center;
    border-radius: 4px;
    white-space: nowrap;
    font-size: 12px;
    height: 100%;

    &.status-disabled {
      border: 1px solid #ffccc7;
      background: #fff1f0;
      color: #f5222d;
    }

    &.status-enabled {
      border: 1px solid #b7eb8f;
      background: #f6ffed;
      color: #52c41a;
    }
  }
}
</style>
